export const Status = {
    loading: 'loading',
    success: 'success',
    error: 'error',
}

export const profileLinks = {
    medium: 'https://medium.com/@sidgangs99',
    linkedin: 'https://www.linkedin.com/in/siddharth-gangwar/',
    twitter: 'https://twitter.com/sidgangs99',
    leetcode: 'https://leetcode.com/stud_64/',
    github: 'https://github.com/sidgangs99',
}

export const mails = {
    gmail: 'sidgangs99@gmail.com',
}

export const blogs = {
    medium: [
        'https://medium.com/@sidgangs99/gfs-google-file-system-architecture-56b3c55a0c4b',
        'https://medium.com/@sidgangs99/map-reduce-how-google-operate-on-large-files-in-gbs-or-tb-s-f3b28487a7ae',
        'https://medium.com/@sidgangs99/its-all-about-engineering-a-load-balancer-types-configuration-algorithms-e7466047eb50',
        'https://medium.com/bloggingtimes/discovering-the-power-of-spatial-indexing-the-key-to-effortless-geographic-data-management-77228909a7cb',
        'https://medium.com/bloggingtimes/unlocking-the-mystery-of-secure-communication-how-symmetric-keys-are-shared-in-https-4fb448a470c8',
        'https://medium.com/bloggingtimes/the-page-token-method-in-bigquery-an-efficient-approach-to-pagination-7d8f2443c69d',
        'https://medium.com/@sidgangs99/garbage-collection-the-importance-of-automatic-memory-management-in-programming-languages-7e99c77eaf09',
        'https://medium.com/@sidgangs99/lets-build-service-discovery-server-system-design-3b27dd4d3f7f',
        'https://medium.com/@sidgangs99/helpful-resources-for-studying-design-patterns-3eb3a57a46c2',
        'https://medium.com/@sidgangs99/leveldb-invented-by-google-and-used-by-cryptocurrencies-like-bitcoin-9fb35f1efb6a',
        'https://medium.com/@sidgangs99/why-i-quit-using-inheritance-instead-started-using-object-composition-732003f03e58',
        'https://medium.com/@sidgangs99/why-are-design-patterns-classified-into-just-3-categories-b2a0e4e0ea72',
    ],
}

export const urlPreviewGeneratorLink =
    process.env.NODE_ENV === 'development'
        ? 'https://some-random-link.com/'
        : 'https://api.peekalink.io/'

export const fallbackUrlPreviewGeneratorLink =
    process.env.NODE_ENV === 'development'
        ? 'https://some-random-fallback-link.com/'
        : 'https://api.linkpreview.net/'

export const peekALinkKey = 'd20d094a-1468-49fe-8ca5-7da5309f86a7'
export const linkPreviewKey = 'de7518a80e44fc152e8096e390d42670'

export const krudAppLink = 'https://tinyurl.com/dbdesigning'

export const resumeDriveLink =
    'https://drive.google.com/drive/folders/1e5B3YZmIa_0Ih1VQLXsnWUW-a8z5ZOr_?usp=share_link'
